export const isActiveOptionItem = (value?: string, activeValue?: string): boolean => {
  if (value && activeValue) return value === activeValue;
  return false;
};
